/**
 * @description 面積單位用
 */
export enum SquareType {
    /** 坪 */
    Feet = 'F',
    /** 平方公尺 */
    Meter = 'M'
}